import React from 'react'
import SeriesPlaceholder from '@/assets/images/placeholder/series.svg'
import MyImage from '../../myImage'
import CustomLink from '../../customLink'
import { S3_PREFIX } from '@/shared/constants'
import { getSlugUrl } from '@/shared/utils'

export default function HeaderDropdown({ subMenu }: any) {
  return (
    <div className="h-64 z-30 absolute transition-all mt-0.5 left-0 w-full text-center dark:bg-[#10171B] bg-white group-hover:visible group-hover:block invisible hidden group-hover:opacity-100 opacity-0">
      <ul className="h-full container w-[auto] overflow-auto overflow-y-hidden inline-flex flex-nowrap align-stretch z-30">
        {subMenu.map((item: any, index: number) => {
          return (
            <React.Fragment key={item?.oSeries?.oSeo?.sSlug}>
              <li className="cursor-pointer transition-all px-4 flex-shrink-0 text-center h-full dark:hover:bg-headersActive dark:hover:border-b-buttonBg hover:border-b-underLine border-b-transparent border-b-[5px] relative group">
                <CustomLink
                  href={getSlugUrl('/' + item?.oSeries?.oSeo?.sSlug)}
                  passHref
                  className="h-full w-full absolute top-0 left-0 opacity-0 z-30 !cursor-pointer"
                  prefetch={false}
                >
                  {item?.oSeries?.sTitle}
                </CustomLink>
                <div className="w-32 h-w-32 pt-10 h-full flex-grow cursor-pointer">
                  <MyImage
                    loadOnScroll
                    placeholderImage={SeriesPlaceholder}
                    className="mb-4 rounded-lg cursor-pointer aspect-square border border-transparent"
                    src={
                      item?.oSeries?.oCategory?.oImg?.sUrl
                        ? `${S3_PREFIX}${item?.oSeries?.oCategory?.oImg?.sUrl}`
                        : SeriesPlaceholder
                    }
                    height={128}
                    width={128}
                    alt={item?.oSeries?.oCategory?.oImg?.sText}
                  />
                  <span className="w-full text-wrap font-bold text-base line-clamp-2">
                    {item?.oSeries?.sSrtTitle || item?.oSeries?.sTitle}
                  </span>
                </div>
              </li>
              {subMenu.length - 1 !== index && <div className="mt-12 min-w-[2px] h-24 bg-c"></div>}
            </React.Fragment>
          )
        })}
      </ul>
    </div>
  )
}
